const tipoIRList = [
    {
        id: 'C',
        descricao: 'Completo',
        ordem: 10,
    },
    {
        id: 'S',
        descricao: 'Simplificado',
        ordem: 20,
    },
    {
        id: 'I',
        descricao: 'Isento',
        ordem: 30,
    },
]

export default tipoIRList